export default __webpack_public_path__ + "static/media/Document_text.bd52455c.svg";